import { useContext } from "react";
import { Redirect } from "react-router-dom";
import StateContext from "../../context/StateContext";

const LoadingPage = (props) => {
	const { loading } = useContext(StateContext);
	const renderPage = () => {
		if (loading) {
			return null;
		}
		if (props.havePlans && props.haveCustomer && !props.haveSegments && !props.haveData) return <Redirect push to={"/introduction"} />;
		if (props.haveData) return <Redirect push to={"/dashboard"} />;
		return <Redirect push to={"/signup"} />;
	};
	return renderPage();
};

export default LoadingPage;
